import { colorFields, eyebrowField } from "./_shared";
/**
 * Video — an embedded YouTube / Vimeo / direct-file clip with an optional
 * title, caption and poster. Five layout variants control framing. Reuses the
 * buyer's existing video-URL parsing (BuyerHeroVideo).
 */
export const videoSchema = {
    type: "video",
    name: { ar: "فيديو", en: "Video" },
    description: {
        ar: "مقطع مدمج من يوتيوب أو فيميو أو ملف مباشر.",
        en: "Embedded YouTube, Vimeo or direct-file clip.",
    },
    maxPerTemplate: 4,
    settings: [
        {
            id: "variant",
            type: "select",
            ui: "thumbnail",
            label: { ar: "نوع العرض", en: "Layout" },
            helpText: { ar: "طريقة عرض الفيديو.", en: "How the video is framed." },
            options: [
                { value: "vid-wide", label: { ar: "عريض", en: "Wide" } },
                { value: "vid-contained", label: { ar: "محتوى", en: "Contained" } },
                { value: "vid-split", label: { ar: "مقسّم", en: "Split" } },
                { value: "vid-cover", label: { ar: "تغطية", en: "Cover" } },
                { value: "vid-rounded", label: { ar: "دائري", en: "Rounded" } },
            ],
            default: "vid-wide",
        },
        ...eyebrowField(),
        {
            id: "title",
            type: "text",
            i18n: true,
            label: { ar: "العنوان (اختياري)", en: "Title (optional)" },
            validate: { max: 80 },
        },
        {
            id: "videoUrl",
            type: "url",
            label: { ar: "رابط الفيديو", en: "Video URL" },
            helpText: {
                ar: "رابط يوتيوب أو فيميو أو ملف MP4.",
                en: "YouTube, Vimeo or an MP4 file URL.",
            },
        },
        {
            id: "videoPoster",
            type: "image",
            focalPoint: true,
            label: { ar: "صورة الغلاف (اختياري)", en: "Poster image (optional)" },
        },
        {
            id: "caption",
            type: "text",
            i18n: true,
            label: { ar: "وصف (اختياري)", en: "Caption (optional)" },
            validate: { max: 160 },
        },
        {
            id: "aspectRatio",
            type: "select",
            label: { ar: "نسبة الأبعاد", en: "Aspect ratio" },
            options: [
                { value: "16:9", label: { ar: "16:9", en: "16:9" } },
                { value: "4:3", label: { ar: "4:3", en: "4:3" } },
                { value: "1:1", label: { ar: "1:1", en: "1:1" } },
            ],
            default: "16:9",
            // A3: the `vid-cover` variant fills a fixed-height frame (`fill`), so the
            // aspect-ratio control does nothing there.
            showIf: {
                variant: ["vid-wide", "vid-contained", "vid-split", "vid-rounded"],
            },
        },
        {
            id: "autoplay",
            type: "checkbox",
            label: { ar: "تشغيل تلقائي (صامت)", en: "Autoplay (muted)" },
            helpText: {
                ar: "يبدأ الفيديو صامتًا تلقائيًا.",
                en: "Starts the video muted automatically.",
            },
            default: false,
        },
        ...colorFields(),
    ],
};
//# sourceMappingURL=video.js.map